<template>
<div>

    <section class="bg-dark2">

      <div class="resultBar d-flex flex-row  justify-content-center align-items-center" v-if="sectionCount>1">
        <div class="categoryCard px-2 align-middle align-items-center" v-for="(cat, idx) in surveyCategories">
          <div class="title_box text-center">
            <div class="subtitle_heading align-middle"><span>{{cat.name | translategrader($i18n.locale)}}</span></div>
            <div class="current_page">{{idx+1}}</div>
          </div>
          <div class="w-100"></div>
          <div class="progress">
            <div class="progress-bar"
              role="progressbar"
              :style="{ 'width': (100*cat.userScore/cat.maxScore)+'%'}"
              :class="{
                'bg-success': (cat.userScore/cat.maxScore>0.66),
                'bg-warning': (cat.userScore/cat.maxScore<=0.66 && cat.userScore/cat.maxScore>0.33),
                'bg-error': (cat.userScore/cat.maxScore<=0.33)
              }"
              :aria-valuenow="100*cat.userScore/cat.maxScore"
              aria-valuemin="0"
              aria-valuemax="100">{{100*cat.userScore/cat.maxScore | number}}%</div>
          </div>
          <div class="w-100"></div>
          <!-- <div class="opinion text-center"
          :class="{
                'color-success': (cat.userScore/cat.maxScore>0.66),
                'color-warning': (cat.userScore/cat.maxScore<=0.66 && cat.userScore/cat.maxScore>0.33),
                'color-error': (cat.userScore/cat.maxScore<=0.33)
              }">
            <span v-if="(cat.userScore/cat.maxScore>0.66)">Yeah!</span>
            <span v-if="(cat.userScore/cat.maxScore<=0.66 && cat.userScore/cat.maxScore>0.33)">Bof</span>
            <span v-if="(cat.userScore/cat.maxScore<=0.33)">Alerte rouge</span>
          </div> -->
        </div>
      </div>


      <div class="container-fluid">
        <header class="masthead mb-auto">


          <div class="row no-gutters">
            <div class="col-md-12" v-if="sectionCount==1">
              <img :src="survey.quizList[0].background_image" class="img-first-section"></img>
            </div>
          </div>


          <div class="row justify-content-md-center text-center">

            <div class="col-md-7">
              <h1 class="main_title"><span>{{profile.company}}</span> <br/><br/>{{settings.copy.home_title | translategrader($i18n.locale)}}</h1>
            </div>
            <div class="w-100"></div>
            <div class="text-center radarChart"  v-if="sectionCount>1">
              <radarchart  :height="600" :width="600"></radarchart>
            </div>
            <div class="w-100"></div>
            <div class="col-md-7">
              <p class="intro_headline">{{$t('front_end.your_score')}}<br/> {{userScorePercent}}%<br /> </p>
            </div>
          </div>

          <div class="row justify-content-md-center text-center">

            <div class="w-100"></div>

            <div class="col-md-5 logo_footer mb-3">
              <img :src="settings.logos.header_overlay" width= "150" style="z-index:99; margin-top: 30px">
            </div>
          </div>
        </header>
      </div>
    </section>

    <div class="background_grey">
      <section class="newPage" v-for="(categoryObject, idx) in survey.quizList">
        <div class="row">
          <render-result-section-print
          :categoryObject=categoryObject
          :score=surveyCategories[idx]
          :categoryIdx=idx
          :sectionCount=sectionCount
          :key=idx
          >
          </render-result-section-print>
        </div>
      </section>
    </div>

</div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import Radarchart from '@/components/RadarChart.vue'
import RenderResultSectionPrint from '@/components/RenderResultSectionPrint.vue'

export default {
  name: 'ResultPrint',
  components: {
    Radarchart,
    RenderResultSectionPrint
  },

  data: function () {
    return {
      userScorePercent: 0
    }
  },

   filters: {
      number(floatNumber){
          return Math.round(floatNumber);
      }
    },

  async created() {

    this.getOrCreateSetting();


    // get the quiz using the id passed in url params
    if (this.$route.params.id !== undefined){
      var payload = {docID: this.$route.params.id};
      await this.getSurveyFromID(payload);

      // Now we have info from the survey, and especially the email from the lead. Let's import the lead's information
      payload = {email: this.survey.email};
      await this.getLeadFromEmail(payload);

      let totalScore = 0;
      let userScore = 0;
      for (let category of this.surveyCategories) {
        // Compute total score
        totalScore += parseInt(category.maxScore);
        userScore += parseInt(category.userScore);
      }

      // update total score data
      this.userScorePercent = Math.round(100 * userScore / totalScore);

    }

  },

  computed: {
    ...mapGetters({
      profile: 'lead/profile',
      survey: 'survey/survey',
      settings: 'settings/settings',
      surveyCategories: 'survey/categories'
    }),

    sectionCount(){
      return this.surveyCategories.length;
    },
  },

  methods: {

    ...mapActions({
      getSurveyFromID: 'survey/getSurveyFromID',
      getLeadFromEmail: 'lead/getLeadFromEmail',
      getOrCreateSetting: 'settings/getOrCreateSetting',
    }),
  }

}
</script>

<style scoped>

html, body {
  background-color: #F3F4F5;
}


@page {
  size: A4;
  max-height:100%;
  max-width:100%;
  margin: 0;
  background-color: #F3F4F5!important;
}

@page :first{
  size: A4;
  margin: 0;
  background-color: #fff;
}

.header_dark {
  background: linear-gradient(0deg, rgba(64,64,64,1) 0%, rgba(37,37,37,1) 100%);
  /*height: 80px!important;*/

}

.background_grey {
  background-color: #F3F4F5;
  size: A4;
  height: 100%;
  min-height: 100%;
}

.main_title_header{
  color: #fff!important;
  font-size: 16px;
  padding-top: 0px;
  margin-top: 0px;
}

.resultBar {
background: #F4F5F6;
height: 122px;
width: 100%;
border-bottom: 1px solid #E6E6E6;
top: 68px;
}

.categoryCard {
  width: 160px!important;
  height: 100%;
  background: #F3F4F5;
  opacity: 1;
  border-left: 1px solid #E6E6E6;
}

.categoryCard:last-child {
  border-right: 1px solid #E6E6E6;
}

.title_box {
  position: relative;
  height: 64px;
}

.title_box .subtitle_heading {
  position: relative;
  text-align: center;
  vertical-align: middle;
  color: #404040;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
  margin-top: 10px;
  padding-top: 5px;
  z-index: 9999!important;
  height: 36px;
  line-height: 36px;
}

.title_box .subtitle_heading span{
  vertical-align:middle;
  display:inline-block;
  line-height:1.8;
}

.title_box .current_page {
  margin-top: -50px;
  margin-bottom: -10px;
  text-align: center;
  color: #e5e5e5;
  font-family: 'andale mono', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 52px;
  opacity: 0.995;
}

.progress {
  border-radius: 8px;
  border: #dbdbdb 1px solid;
  height: 15px;
  background-color: #fff;
}

.bg-success {
  background-color: #139A43!important;
}
.bg-warning {
  background-color: #FC8F00!important;
}
.bg-error {
  background-color: #DC0000!important;
}

.color-success {
  color: #139A43!important;
}
.color-warning {
  color: #FC8F00!important;
}
.color-error {
  color: #DC0000!important;
}


.introPage {
  background-color: #FFF;
  width: parent;
}

.introPage .intro_Edito{
  padding-top: 30mm;
  padding-left: 20mm;
  padding-right: 20mm;
  line-height: 2em;
}

.introPage h1 {
  margin-bottom: 30px;
}

.image_intro {
  width: 100%;
  margin: 0 auto;
  padding-top: 50px!important;
}

html, body {
  width: 210mm!important;
  height: 297mm!important;
  background: #fff;
}

.app,.theme--light.application {
  background: #fff!important;
}

.logo_footer {
  position: fixed;
  bottom: 10px;
  z-index: 999;
}

.bg-dark2{
  background: #fff;
}
.radarChart {
  align: center;
  margin: 0 auto;
  width: 700px;
  padding: 0px;
}

.masthead {
  padding-top: 0px;
  padding-bottom: 80px;
}

.main_title{
  padding-top: 0px;
}
.main_title span{
  color: #444;
  font-size: 40px;
}

h1.main_title {
  color: #00AFF0;
  font-size: 45px;
  font-family: 'Nunito', sans-serif;
  font-weight: semi-bold;
  margin-top: 10px;
  margin: 10px 15% 10px 15%;
}

.intro_headline {
  color: #444;
  font-family: 'Nunito', sans-serif;
  font-size: 34px;
  margin: 30px 0 20px;
  font-weight: bold;
}

.newPage{
  page-break-before: always;
}

section :first-of-type {
  page-break-before: avoid!important;
}



/* SINGLE QUIZZ */

.img-first-section {
  max-width: calc(100% + 40px);
  width: calc(100% + 40px);
  margin-left: -20px;
  margin-right: -20px;
  margin-top : 0px;
  padding-top: 0px;
  margin-bottom : 200px;
}

.single-quiz-spaces {
  margin-top: 200px !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/results/ResultPrintPage.vue